import Host from "@interfaces/device/host"
import axiosApiInstance from "@services/custom-axios-instance"
import { generateUrl } from "@services/generateUrl/generateUrl"


export function getHostsByOrganizationId(organizationId: number): Promise<Host[]> {
    return axiosApiInstance.get(`${generateUrl()}/drproxservices/devices/hosts/${organizationId}`)
        .then((response) => {
            const hosts = response.data as unknown
            console.log(hosts)
            return hosts as Host[]
        })
}

export function saveHost(host: Host) {
    return axiosApiInstance.post(`${generateUrl()}/drproxservices/device/host/`, host)
        .then((response) => {
            const hostResponse = response.data as unknown
            return hostResponse as { code: string, message: string, response: string}
        });
}

export const editHost = async (host: Host) => {
  try {
    return await axiosApiInstance.put(`${generateUrl()}/drproxservices/device/host`, host)
  } catch (e) {
    throw new Error('something was wrong');
  }
};


export const deleteHosts = async (deviceHostId: string) => {
    try {
      return await axiosApiInstance.delete(`${generateUrl()}/drproxservices/device/host/${deviceHostId}`)
    } catch (e) {
      throw new Error('something was wrong');
    }
  };

export const connectionHost = async (host: Host) => {
  try {
    return await axiosApiInstance.post(`${generateUrl()}/drproxservices/device/connection`, host)
  } catch (e) {
    throw new Error('something was wrong');
  }
};